import Vue from 'vue';
import Vuex from 'vuex';
import accountModule from './account';
import appointmentsModule from './appointments';
import babybook from './babybook';
import bills from './bills';
import callsModule from './calls';
import clinicQr from './clinic-qr';
import files from './files';
import medicine from './medicine';
import partner from './partner'
import pharmacyOrder from './pharmacy-order';
import routing from './routing-state';
import toast from './toast';
import messages from './messages';
import program from './program';
import ondemand from './ondemand';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    accountModule,
    appointmentsModule,
    babybook,
    bills,
    callsModule,
    clinicQr,
    files,
    medicine,
    partner,
    pharmacyOrder,
    routing,
    toast,
    messages,
    program,
    ondemand,
  },
});
